module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chaptitle",
    attrs: {
      "id": "ch2"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _c('a', {
    attrs: {
      "href": "#/Text/Contents#rch2"
    }
  }, [_vm._v("Succeeding as a Small-Scale Organic Vegetable Grower")])])]), _vm._v(" "), _c('p', {
    staticClass: "epigraph"
  }, [_c('span', [_c('i', [_c('b', [_c('span', {
    staticClass: "green"
  }, [_vm._v("To obtain the best yield from the soil, without excessive expenses, through the judicious selection of crops, and through appropriate work: such is the goal of the market gardener.")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "epigraphr"
  }, [_c('span', [_vm._v("− J. G. Moreau and J. J. Daverne, "), _c('i', [_vm._v("Manuel pratique de la culture maraîchère de Paris")]), _vm._v(", 1845")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', [_vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ECAUSE OUR MICRO")]), _vm._v("-"), _c('span', {
    staticClass: "small"
  }, [_vm._v("FARM")]), _vm._v(" has garnered so much media attention in recent years, farmers of all stripes and many agronomists have been coming to meet us and visit our gardens. These people, most of them only familiar with modern large-scale conventional farming, are curious about our work because we challenge the belief that the small family farm cannot stay afloat in today’s economy. Despite our decade of experience in proving the viability of a micro-farm, most of these visitors remain unconvinced. They find it difficult to wrap their heads around the fact that we have no plans to make major investments and that we intend to stay small and continue working with hand tools. A bank loan officer who visited us adamantly declared as she left that we were not real business people, and that our farm was not a real farm!")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_vm._v("Our farming choices may be easier to understand when one stops to consider the obstacles that beginning farmers must face when they are just getting started. For us, the decision to grow vegetables on a small plot of land, while minimizing start-up investments, simply had to do with our financial reality at the time. When we were in our early twenties, our financial resources were limited and we felt strongly about the importance of minimizing our debt load. Ten years later, our strategy of starting a farm without a large capital expense, while still producing high yields of vegetables for direct sales, has proved to be lucrative. Our market garden demonstrates that high profits can be earned "), _c('i', [_vm._v("without")]), _vm._v(" high costs.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_vm._v("For beginning farmers, there are a number of advantages to “starting small”—but there is also much to be said for staying small in the years that follow. That being said, whatever the size of the planned operation, it is important to understand "), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _vm._v("the implications of different production strategies in order to make wise choices about how to best succeed as an organic vegetable grower. This chapter touches on a few factors which, in my opinion, are at the heart of our market gardening success.")])]), _vm._v(" "), _c('p', {
    staticClass: "imagec"
  }, [_c('span', [_c('img', {
    attrs: {
      "alt": "When crops are closely spaced on a bed, the plant leaves come to rapidly touch one another, creating a beneficial microclimate. This canopy reduces weed growth, helps retain moisture in the soil, and protects the crop from wind damage.",
      "height": "389",
      "src": "Images/f0006-01.jpg",
      "width": "453"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', [_c('span', {
    staticClass: "green"
  }, [_c('b', [_c('i', [_vm._v("When crops are closely spaced on a bed, the plant leaves come to rapidly touch one another, creating a beneficial microclimate. This canopy reduces weed growth, helps retain moisture in the soil, and protects the crop from wind damage")])]), _vm._v(".")])])]), _vm._v(" "), _c('p', {
    staticClass: "subheading",
    attrs: {
      "id": "sec3"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Text/Contents#rsec3"
    }
  }, [_vm._v("A Biologically Intensive Approach")])])]), _vm._v(" "), _c('p', {
    staticClass: "normala"
  }, [_c('span', [_vm._v("The term “biointensive”* broadly refers to a horticultural method in which growers maximize crop yields from a minimum area of land, while seeking to preserve—or even improve—the quality of the soil. Drawing on the experience of 19th-century French vegetable growers and Rudolph Steiner’s biodynamic principles, the biointensive method was refined in northern California beginning in the 1960s.")])]), _vm._v(" "), _c('div', {
    staticClass: "boxg"
  }, [_c('div', {
    staticClass: "hide"
  }), _vm._v(" "), _c('div', {
    staticClass: "hide"
  }, [_c('hr')]), _vm._v(" "), _c('p', {
    staticClass: "normalbr"
  }, [_c('span', [_c('span', {
    staticClass: "green"
  }, [_c('b', [_c('i', [_vm._v("In some circles, the word “biointensive” refers to a very narrowly defined set of practices and techniques. Some people have even tried to trademark the approach. I generally prefer the expression “biologically intensive,” and I will use it more often in this book, but both refer to the same ideas and principles")])]), _vm._v(".")])])]), _vm._v(" "), _c('div', {
    staticClass: "hide"
  }, [_c('hr')]), _vm._v(" "), _c('div', {
    staticClass: "hide"
  })]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_vm._v("There is now a whole literature on biologically intensive vegetable growing methods, and although the techniques most often discussed in these works (see bibliography for recommended reading) are geared towards home gardening, a number of the practices can be useful in the context of commercial production. We took one such approach in developing our cropping system.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_vm._v("To begin with, we have not arranged our garden in the rows typically used in mechanized farming where crops are spaced according to the dimensions of the tractors and weeding machinery. Instead, we grow our crops in permanent raised beds. While establishing the beds, we invested in a large quantity of organic matter with the idea of quickly creating a rich and living soil. We effectively "), _c('i', [_vm._v("built")]), _vm._v(" our soil this way. Since then, "), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _vm._v("we’ve continued to add compost regularly while limiting any turning of the soil to just the surface, thereby keeping the structure as intact as possible. For deep soil cultivation, we use a broadfork ("), _c('i', [_vm._v("grelinette")]), _vm._v(" in French) which allows us to aerate the soil without turning it. The purpose of this cultivation is to create loose, fertile soil, which encourages the crop roots to spread downward rather than sideways. This in turn makes it possible to plant the crops quite close together without them running into each other at the root level.")])]), _vm._v(" "), _c('p', {
    staticClass: "imagec"
  }, [_c('span', [_c('img', {
    attrs: {
      "alt": "Mechanized farming, whether conventional or organic, spaces the rows of crops according to the dimensions of the tractors and the weeding machinery. Since we use only hand-powered tools to control weeds on our farm, we do not have this limitation.",
      "height": "343",
      "src": "Images/f0007-01.jpg",
      "width": "537"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', [_c('span', {
    staticClass: "green"
  }, [_c('b', [_c('i', [_vm._v("Mechanized farming, whether conventional or organic, spaces the rows of crops according to the dimensions of the tractors and the weeding machinery. Since we use only hand-powered tools to control weeds on our farm, we do not have this limitation")])]), _vm._v(".")])])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext-ts"
  }, [_c('span', [_vm._v("The goal is to space the crops such that their leaves touch each other when the plants reach three quarters of their full size. At maturity, the foliage will cover all of the growing area, effectively creating a living mulch. This strategy of closely spacing the crops (in addition to allowing high yields per square foot) has two main advantages. The first is that it greatly cuts down on the amount of weeding required, and the second is that it renders many day-to-day gardening tasks more efficient. These benefits will be explained in detail throughout this book.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_vm._v("In our gardens, it is the quality of the soil structure, combined with the microbe- and nutrient-rich compost that we use, which allows intensive spacing to work well. It took us a few years of trial and error to determine the proper spacing for each crop—so that they are planted as densely as possible without limiting their size at maturity—but it was a worthwhile effort. We also sought to further maximize our growing space by planting as many succession crops as possible. This means that we must determine the length of time each "), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _vm._v("crop spends in the garden and plan our seedings so that harvested crops are replaced by new ones as soon as they are out of the garden. Using our crop plan, we succeed in producing multiple successive harvests each season in the same space.")])]), _vm._v(" "), _c('p', {
    staticClass: "imagec"
  }, [_c('span', [_c('img', {
    attrs: {
      "alt": "If the growing area is, for example, five times more densely planted, covering crops with a row cover will take one fifth of the time and use one fifth of the material to do the same job, saving both time and money. Similar efficiencies are also true for irrigation, mulching, and weeding.",
      "height": "324",
      "src": "Images/f0008-01.jpg",
      "width": "611"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', [_c('span', {
    staticClass: "green"
  }, [_c('b', [_c('i', [_vm._v("If the growing area is, for example, five times more densely planted, covering crops with a row cover will take one fifth of the time and use one fifth of the material to do the same job, saving both time and money. Similar efficiencies are also true for irrigation, mulching, and weeding")])]), _vm._v(".")])])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext-ts"
  }, [_c('span', [_vm._v("Most of the thinking behind biologically intensive methods is not so very different from the principles of organic agriculture. In both cases, the objective is to build rich, loose, fertile soil. But biointensive practices stress the importance of building soil in order to achieve this. Planting closely spaced crops in permanent beds is what allowed us to establish ourselves in farming without mechanizing our operation. These are not new ideas, and we do not pretend to have invented them. If we can take credit for anything, it’s that we developed a good regime for making our market garden highly productive in a cold Canadian climate while favoring an approach that sustains soil quality.")])]), _vm._v(" "), _c('p', {
    staticClass: "subheading",
    attrs: {
      "id": "sec4"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Text/Contents#rsec4"
    }
  }, [_vm._v("Minimizing Start-Up Costs")])])]), _vm._v(" "), _c('p', {
    staticClass: "normala"
  }, [_c('span', [_vm._v("Starting a farm requires investing in tools and equipment, but by starting small and growing crops intensively, it is possible to do so without a large capital outlay. Here is a list of the investments I feel are necessary to run an efficient vegetable operation on less than two acres (1 hectare). The approximate dollar amounts listed are in Canadian funds and are for new equipment which should last many years.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal-ts"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _vm._v("The start-up costs total $39,000. This may sounds like a lot of money to start a micro-farm, but one should consider the following. Firstly, a bank loan of $39,000 spread out over 5 years at 8% interest per year means that the annual investment is about $9,500—which is little enough compared to the potential revenue of a market garden. Of course, these will not be one’s only business expenses. This figure does not include certain necessities such as a delivery vehicle, land rental/purchase fees, mortgages, or other variable costs (inputs, administration fees, supplies, etc.). But even so, initial costs are still relatively small, especially when compared to the cost of equipment used in mechanized vegetable growing.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_vm._v("Secondly, some of these items can be purchased secondhand or gradually with time. We were fortunate enough to find used hoophouses for a fraction of their original price. Also, we didn’t buy our rotary harrow and flame weeder until several years into our operation. When we began, we committed to producing 30 CSA shares in our first season and 50 in our second. At that time, we did all our harvesting on the morning of delivery day, which saved us the problem of having to refrigerate our vegetables. Later, when we upped our production to 100 shares and had to take a whole day to harvest them, a cold room became necessary.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_vm._v("Having said that, even though certain tools on this list may not be absolutely necessary in your first season, they do make the work much more efficient and pay for themselves quickly. This is why we have never shied away from trying out new equipment. When we first began, we seeded by hand all the crops that do not transplant well (e.g., carrots, radish, mesclun mix). Those were long jobs. But when we started using the seeders described later in this book, we were able to seed beds two or three times longer in one fifth of the time. When you stop to consider the extra workload required the first few seasons, it makes sense to make the optimization of operations a priority. In my opinion, it is best not to hold off too long on getting the right equipment for the job.")])]), _vm._v(" "), _c('div', {
    staticClass: "boxg1"
  }, [_c('div', {
    staticClass: "hide"
  }), _vm._v(" "), _c('div', {
    staticClass: "hide"
  }, [_c('hr')]), _vm._v(" "), _c('p', {
    staticClass: "boxtitle"
  }, [_c('span', [_vm._v("Start-up Costs for Market Gardening")])]), _vm._v(" "), _c('div', {
    staticClass: "hide"
  }, [_c('p', {
    staticClass: "imagec"
  }, [_c('span', [_c('img', {
    attrs: {
      "alt": "",
      "height": "440",
      "src": "Images/f0009-02.jpg",
      "width": "383"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "rhide"
  }, [_c('p', {
    staticClass: "imagec"
  }, [_c('span', [_c('img', {
    attrs: {
      "alt": "",
      "height": "440",
      "src": "Images/f0009-01.jpg",
      "width": "383"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "hide"
  }, [_c('hr')]), _vm._v(" "), _c('div', {
    staticClass: "hide"
  })]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_vm._v("In most countries, there are different kinds of government assistance programs in the form of "), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _vm._v("loans and grants for new farmers that can help out with the financing for agricultural equipment. We were lucky to have received financial aid when we started Les Jardins de la Grelinette. With this kind of added support, the chances of succeeding at market gardening will greatly improve. But grants or no grants, one fact remains: keeping costs low when starting a business reduces financial risk and ensures profitability over the short term. This is a winning business model in and of itself.")])]), _vm._v(" "), _c('p', {
    staticClass: "subheading",
    attrs: {
      "id": "sec5"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Text/Contents#rsec5"
    }
  }, [_vm._v("Minimizing Production Costs")])])]), _vm._v(" "), _c('p', {
    staticClass: "normala"
  }, [_c('span', [_vm._v("Revenue minus expenses equals profit. This simple equation must always be kept in mind. Obviously no one goes into farming to get rich, but one should always aim for profitability when starting a farm. Having a profitable operation spares you from daily financial stresses, prevents you from needing to find off-farm employment during the winter, and allows you to set aside money for retirement. (Yes, this is possible with a micro-farm.) Profit is ultimately what keeps the operation sustainable. Many people get into organic farming for philosophical reasons or as part of a search for meaning, but at the end of the day, market gardening is a business, and it is important to treat it like one.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_vm._v("Most vegetable growers today increase business revenue by upping production and sales in order to see a return on the cost of their equipment. "), _c('i', [_vm._v("Scaling-up your operation")]), _vm._v(" has become a popular topic at conferences and in magazines on organic market farming. But when operating a market garden, one needs to look at economics from a different point of view. While there are many kinds of ways to maximize the amount of land under cultivation when mechanized, this is not the case when using the tools and techniques described in this handbook. The production model itself is the limiting factor. So returning to the equation above, if the revenue is finite and you still want profit to be high, this means expenses must be low. This is the logic that market gardeners should follow: keep operating at low cost.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_vm._v("Reducing start-up costs is a good first step. Avoiding mechanization and machinery-related costs (purchase, fuel, maintenance, etc.) is another one. But the most important step of all is limiting dependence on outside labor, which generally accounts for 50% of the production costs of a diversified market farm."), _c('a', {
    attrs: {
      "href": "#/Text/#st1",
      "id": "rst1"
    }
  }, [_vm._v("*")]), _vm._v(" In a market garden such as ours, the bulk of the work is usually done by the owner-operators with the help of one or two seasonal workers, depending on the area under cultivation and the number of greenhouses. The major operating costs are thus reduced to inputs (amendments, seeds, plant protection products), which are generally quite minimal.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_vm._v("In the last 15 years, Lynn Byczynski, the editor of the American magazine "), _c('i', [_vm._v("Growing for Market")]), _vm._v(", has had the chance to meet with many small-scale vegetable growers. In her book "), _c('i', [_vm._v("Market Farming Success")]), _vm._v(", she discussed the potential revenues of market gardening and found that the net profit margin of most of these farmers is about 50%. This means that if the total sales revenue is $80,000, about one half goes to operating costs, including "), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _vm._v("external labor and fixed costs. She points out that while the 50% margin depends on many factors, it is still relatively consistent regardless of farm gross sales. This percentage is in line with the figures on our farm and is very telling of how profitable market gardening can be. It goes to show that it is possible to maintain high productivity with little in the way of costs.")])]), _vm._v(" "), _c('p', {
    staticClass: "subheading",
    attrs: {
      "id": "sec6"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Text/Contents#rsec6"
    }
  }, [_vm._v("Direct Selling")])])]), _vm._v(" "), _c('p', {
    staticClass: "normala"
  }, [_c('span', [_vm._v("Direct selling of local products is at the heart of today’s renaissance of non-industrial-scale farming. Essentially, it allows producers to recover part of the profit commonly scooped up by distributors and wholesalers. Most grocery stores or food markets take a cut of between 35% and 50% of the selling price. The distributor, which transports and handles the product, takes another 15% to 25%. So, for a salad that sells for $2 in the store, the vegetable grower selling through conventional distribution channels makes about $0.65. This effectively means that if this grower doesn’t participate in selling, he or she is missing out on two thirds of the value of his product—a sizable chunk. By comparison, market farmers who use direct selling channels make the full amount with every sale. We can conclude that these producers can afford to produce one third as much volume and still earn the same income.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_vm._v("There are several forms of direct selling (also known as short supply chains). Examples include community-supported agriculture (CSA), farmers’ markets, solidarity markets, and farmgate sales. Vegetable growers who are just getting established in farming should consider these niches if they hope to prosper over the long term. Moreover, the work we do as farmers addresses a need felt by a growing number of people who want to support and get to know local producers. One of the benefits of direct selling is that it provides confidence to consumers by ensuring safe, nutritious, and responsibly produced food, which is not always readily available in today’s globalized food system.")])]), _vm._v(" "), _c('div', {
    staticClass: "boxg1"
  }, [_c('div', {
    staticClass: "hide"
  }), _vm._v(" "), _c('div', {
    staticClass: "hide"
  }, [_c('hr')]), _vm._v(" "), _c('p', {
    staticClass: "boxtitlel"
  }, [_c('span', [_vm._v("Advantages of the CSA Model")])]), _vm._v(" "), _c('p', {
    staticClass: "normalb"
  }, [_c('span', [_c('b', [_vm._v("GUARANTEED SALES:")]), _vm._v(" The main advantage of the CSA model is that production is prepaid at the start of the season, often before the first seed has been sown. This model allows the farmer to budget with greater precision. There is nothing better for a solid business plan than guaranteed sales.")])]), _vm._v(" "), _c('p', {
    staticClass: "normalb-ts"
  }, [_c('span', [_c('b', [_vm._v("SIMPLER PRODUCTION PLANS:")]), _vm._v(" Since members have already purchased the produce, the farmer can plan production based on the sales. Once the number of customers has been determined, the contents of each share can be planned out beforehand. This is all the more important for growers who do not yet have much farming experience to go on.")])]), _vm._v(" "), _c('p', {
    staticClass: "normalb-ts"
  }, [_c('span', [_c('b', [_vm._v("RISK SHARING:")]), _vm._v(" The idea behind CSA is that the risks inherent to agriculture are shared between the family farmer and the members. When members sign up, they sign a contract inviting them to be tolerant in case of hail, drought, or any other natural catastrophe. If the season is good, the members will receive more than planned, but if the season is bad, they will receive less. It is like taking out an insurance plan on the harvest.")])]), _vm._v(" "), _c('p', {
    staticClass: "normalb-ts"
  }, [_c('span', [_c('b', [_vm._v("CUSTOMER LOYALTY:")]), _vm._v(" CSA allows farmers to build not just customer loyalty but tangible relationships between consumers and the farm. On our farm, many members have been receiving vegetables from us for many years now. These people know us, have come out to visit the gardens, and greatly appreciate the work we do. As its name suggests, CSA really does have the power to build community.")])]), _vm._v(" "), _c('p', {
    staticClass: "normalb-ts"
  }, [_c('span', [_c('b', [_vm._v("NETWORKING:")]), _vm._v(" CSA is even more advantageous when a third organization can play a coordinating role. This is the case in Quebec, where Équiterre promotes CSA through publicity campaigns and finds members for the farms through its network. In addition, Équiterre provides training on production planning for new farmers, links them with more experienced growers through mentorships, and organizes visits to other operations. These are very helpful and useful services for any beginning vegetable farmer.")])]), _vm._v(" "), _c('p', {
    staticClass: "normalb-ts"
  }, [_c('span', [_vm._v("For more information visit "), _c('a', {
    attrs: {
      "href": "http://equiterre.org",
      "target": "_blank"
    }
  }, [_vm._v("equiterre.org")])])]), _vm._v(" "), _c('div', {
    staticClass: "hide"
  }, [_c('hr')])]), _vm._v(" "), _c('p', {
    staticClass: "imagec"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _c('img', {
    attrs: {
      "alt": "The development of farmers’ markets and CSA are a sign that citizens are taking back the agricultural economy. Once people get a taste for real food, most don’t want to rely on supermarkets anymore. This creates a lot of opportunity for new farmers.",
      "height": "446",
      "src": "Images/f0012-01.jpg",
      "width": "557"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', [_c('span', {
    staticClass: "green"
  }, [_c('b', [_c('i', [_vm._v("The development of farmers’ markets and CSA are a sign that citizens are taking back the agricultural economy. Once people get a taste for real food, most don’t want to rely on supermarkets anymore. This creates a lot of opportunity for new farmers")])]), _vm._v(".")])])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext-ts"
  }, [_c('span', [_vm._v("That being said, one could ask which mode of direct selling is better than others. This is hard to answer, since each model has its advantages and disadvantages, and each farm has its own needs. In our particular case, although we sell our produce at two farmers’ markets, CSA has always been the preferred option since it guarantees sales and simplifies our production plan. In my opinion, the many advantages of CSA make it a sales outlet tailor-made for new market gardeners.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_vm._v("Whatever model one chooses, the point of direct selling is to build a loyal base of customers and develop an interdependent relationship with them. When it comes to customer loyalty, the quality of the products is very important. One should never neglect the importance of presentation (for instance, always washing the vegetables) and the importance of identifying your production with a distinctive logo. Another key to success with direct selling is to be welcoming and open to sharing information with people who "), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _vm._v("may be—for the first time in their lives—asking questions about where their food comes from. This is why we have always felt it important to be present at market stands and drop-off points. As growers it is important that we never lose sight of the fact that small-scale production is viable today because there is a movement among consumers to support artisan producers. Putting our faces alongside the vegetables helps to make this possible.")])]), _vm._v(" "), _c('p', {
    staticClass: "subheading",
    attrs: {
      "id": "sec7"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Text/Contents#rsec7"
    }
  }, [_vm._v("Adding Value to the Crops")])])]), _vm._v(" "), _c('p', {
    staticClass: "normala"
  }, [_c('span', [_vm._v("In 2012, a five-pound bag of organic carrots sold for about $6 in the grocery store ($1.20 per pound), while the same carrots in a bunch sold for $2.50 per pound. The value of the carrots more than doubled simply by leaving the leaves on to indicate freshness. This is an example of adding value to the crops. Not all vegetables grown are of equal market value, and it is wise to invest one’s energies in producing the ones that command a higher price. The first step in this regard is determining which crops are the most profitable. For exploring these ideas, there are a number of resources out there for diversified vegetable growers. The book "), _c('i', [_vm._v("Crop Planning for Organic Vegetable Growers")]), _vm._v(", written by Dan Brisebois and Fred Thériault, two young growers from Quebec, is one that I highly recommend.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_vm._v("At our farm, we went through the exercise of quantifying the value of our production by measuring not only the total sales of each crop, but also the space and time it took to grow them. We looked at space since it is a limited resource that must be used efficiently; we looked at time in order to plan the succession of crops in the same beds. The table on "), _c('a', {
    attrs: {
      "href": "#/Text/Chapter002#page_14"
    }
  }, [_vm._v("page 14")]), _vm._v(" shows our results. Using this as a reference, we can observe, for example, that growing greenhouse cucumbers is four times as profitable as growing turnips. Or, that a bed of lettuce brings in as much as leeks, but in half the time. This practical tool makes it easy to see which crops can perform best in the market garden.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_vm._v("While prioritizing the most profitable crops is an important factor for deciding which ones to grow more of, there are other means of maximizing potential sales from the garden. Investigating various options and strategies is essential when competing with supermarket vegetables produced in the industrial agri-food system (where prices are sometimes very low) and with other vegetable growers selling directly (where freshness and quality are excellent).")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_vm._v("The box on "), _c('a', {
    attrs: {
      "href": "#/Text/Chapter002#page_15"
    }
  }, [_vm._v("page 15")]), _vm._v(" lists some of the strategies we have adopted at Les Jardins de la Grelinette. These strategies are neither original nor guaranteed to succeed on their own, but have helped our business significantly.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_vm._v("Since prices vary depending on quality, growing top-notch vegetables represents the greatest challenge for a beginner. But once this goal is achieved, prioritizing certain crops and finding creative ways to differentiate products will make any market garden significantly more profitable.")])]), _vm._v(" "), _c('p', {
    staticClass: "subheading",
    attrs: {
      "id": "sec8"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Text/Contents#rsec8"
    }
  }, [_vm._v("Learning the Craft")])])]), _vm._v(" "), _c('p', {
    staticClass: "normala"
  }, [_c('span', [_vm._v("If you are reading this book, chances are that you are interested in market gardening as a livelihood. Whether you want to live in the countryside, work with the rhythms of the seasons, or have a more down-to-earth lifestyle, the farming vocation can be an attractive one. However, as accessible as market gardening is, growing more than forty different kinds of vegetables intensively does require know-how and a work ethic that few other vocations demand. Market gardening, just like market farming on bigger farm, is tough work, and proper training is recommended.")])]), _vm._v(" "), _c('p', {
    staticClass: "subheading1"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _vm._v("Typical Annual Sales at Les Jardins de la Grelinette")])]), _vm._v(" "), _c('p', {
    staticClass: "imagea"
  }, [_c('span', [_c('img', {
    staticClass: "imagefix",
    attrs: {
      "alt": "Typical Annual Sales at Les Jardins de la Grelinette",
      "src": "Images/f0014-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "captions"
  }, [_c('span', [_vm._v("* All beds are 100' long.")])]), _vm._v(" "), _c('p', {
    staticClass: "captions"
  }, [_c('span', [_vm._v("** Profitability is based on a coefficient that takes into account total sales, yield per bed, and the number of growing days in the garden.")])]), _vm._v(" "), _c('p', {
    staticClass: "captions"
  }, [_c('span', [_c('b', [_vm._v("Note:")]), _vm._v(" The figures in this table are based on data gathered over a number of seasons. They were calculated based on the allocation of our sales (65% CSA and 35% market) and the large amount of mesclun mix we sell to retailers. They give a good indication of the most—and least—profitable vegetables to grow.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext-ts"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }), _vm._v("The best advice that I can offer someone interested in learning the craft is to get first-hand experience on an established mixed vegetable operation. No matter what size it is, your effort will let you see for yourself the joys and pains of the trade. No school or book can replace the experience of growing food for a season and taking in—often subconsciously—all the practices another vegetable farmer does well (or less well). In this regard, it’s very important to work on a farm where the farmer is seriously interested in passing his experience on to others. From what I have observed, I believe it takes commitment to at least one full season to know if you are cut out for this kind of work and lifestyle.")])]), _vm._v(" "), _c('div', {
    staticClass: "boxg1"
  }, [_c('div', {
    staticClass: "hide"
  }), _vm._v(" "), _c('div', {
    staticClass: "hide"
  }, [_c('hr')]), _vm._v(" "), _c('p', {
    staticClass: "boxtitlel"
  }, [_c('span', [_vm._v("Our Strategies for Commanding Good Prices")])]), _vm._v(" "), _c('p', {
    staticClass: "bull0"
  }, [_c('span', [_c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "Images/bull.jpg"
    }
  }), _c('span', {
    staticClass: "hide"
  }, [_c('img', {
    staticClass: "inline1",
    attrs: {
      "alt": "",
      "height": "15",
      "src": "Images/bull.jpg",
      "width": "16"
    }
  })]), _c('span', {
    staticClass: "hide"
  }), _vm._v("We focus on the quality and freshness of our vegetables.")])]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', [_c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "Images/bull.jpg"
    }
  }), _c('span', {
    staticClass: "hide"
  }, [_c('img', {
    staticClass: "inline1",
    attrs: {
      "alt": "",
      "height": "15",
      "src": "Images/bull.jpg",
      "width": "16"
    }
  })]), _c('span', {
    staticClass: "hide"
  }), _vm._v("We favor root vegetables that can be sold with their leaves, demonstrating that the crops are fresh.")])]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', [_c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "Images/bull.jpg"
    }
  }), _c('span', {
    staticClass: "hide"
  }, [_c('img', {
    staticClass: "inline1",
    attrs: {
      "alt": "",
      "height": "15",
      "src": "Images/bull.jpg",
      "width": "16"
    }
  })]), _c('span', {
    staticClass: "hide"
  }), _vm._v("We avoid storage vegetables (potatoes, parsnips, winter squash, rutabagas, etc.), which for the most part take up space in the garden for a long time and cannot be marketed as fresh. We have developed expertise in two crops that we deem most profitable: mesclun and greenhouse tomatoes, which we distribute through restaurants, a local grocer, as well as our direct selling channels.")])]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', [_c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "Images/bull.jpg"
    }
  }), _c('span', {
    staticClass: "hide"
  }, [_c('img', {
    staticClass: "inline1",
    attrs: {
      "alt": "",
      "height": "15",
      "src": "Images/bull.jpg",
      "width": "16"
    }
  })]), _c('span', {
    staticClass: "hide"
  }), _vm._v("We choose the tastiest cultivars (different varieties of the same vegetable), since we want to encourage our members and customers to discover new tastes.")])]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', [_c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "Images/bull.jpg"
    }
  }), _c('span', {
    staticClass: "hide"
  }, [_c('img', {
    staticClass: "inline1",
    attrs: {
      "alt": "",
      "height": "15",
      "src": "Images/bull.jpg",
      "width": "16"
    }
  })]), _c('span', {
    staticClass: "hide"
  }), _vm._v("We regularly try different or unusual cultivars in order to keep our members and customers interested.")])]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', [_c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "Images/bull.jpg"
    }
  }), _c('span', {
    staticClass: "hide"
  }, [_c('img', {
    staticClass: "inline1",
    attrs: {
      "alt": "",
      "height": "15",
      "src": "Images/bull.jpg",
      "width": "16"
    }
  })]), _c('span', {
    staticClass: "hide"
  }), _vm._v("We supplement our production with vegetables purchased from producers who specialize in crops that we have chosen not to grow.")])]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', [_c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "Images/bull.jpg"
    }
  }), _c('span', {
    staticClass: "hide"
  }, [_c('img', {
    staticClass: "inline1",
    attrs: {
      "alt": "",
      "height": "15",
      "src": "Images/bull.jpg",
      "width": "16"
    }
  })]), _c('span', {
    staticClass: "hide"
  }), _vm._v("We force our early-season crops in order to be the first to offer them at market.")])]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', [_c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "Images/bull.jpg"
    }
  }), _c('span', {
    staticClass: "hide"
  }, [_c('img', {
    staticClass: "inline1",
    attrs: {
      "alt": "",
      "height": "15",
      "src": "Images/bull.jpg",
      "width": "16"
    }
  })]), _c('span', {
    staticClass: "hide"
  }), _vm._v("We change our prices as little as possible, and explain to our customers and members the negative effects of “dumping” that drives grocery store prices down.")])]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', [_c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "Images/bull.jpg"
    }
  }), _c('span', {
    staticClass: "hide"
  }, [_c('img', {
    staticClass: "inline1",
    attrs: {
      "alt": "",
      "height": "15",
      "src": "Images/bull.jpg",
      "width": "16"
    }
  })]), _c('span', {
    staticClass: "hide"
  }), _vm._v("We always wash our vegetables and display them neatly.")])]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', [_c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "Images/bull.jpg"
    }
  }), _c('span', {
    staticClass: "hide"
  }, [_c('img', {
    staticClass: "inline1",
    attrs: {
      "alt": "",
      "height": "15",
      "src": "Images/bull.jpg",
      "width": "16"
    }
  })]), _c('span', {
    staticClass: "hide"
  }), _vm._v("We guarantee satisfaction with our products at all times, no questions asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', [_c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "Images/bull.jpg"
    }
  }), _c('span', {
    staticClass: "hide"
  }, [_c('img', {
    staticClass: "inline1",
    attrs: {
      "alt": "",
      "height": "15",
      "src": "Images/bull.jpg",
      "width": "16"
    }
  })]), _c('span', {
    staticClass: "hide"
  }), _vm._v("We have taken the time to design an eye-catching logo that clearly identifies our products. At the local grocery store, customers swear by our products, which they recognize easily. They know that they are supporting the farm down the road.")])]), _vm._v(" "), _c('div', {
    staticClass: "hide"
  }, [_c('hr')]), _vm._v(" "), _c('div', {
    staticClass: "hide"
  })]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }), _vm._v("That being said, there is no substitute for the experience one gains by working for oneself. This is why, after spending some time on someone else’s farm, I would suggest beginning your own project. Market gardening allows the chance to get going little by little. One can start without much in the way of investment, gradually expanding the size of the plot as confidence and skills increase. Starting a CSA of 30 baskets is not such a big thing, especially given that most of the families can be friends and acquaintances. Bringing what you have grown to a nearby farmers’ market is also an option. This can be done on a part-time basis and involves less commitment. We should not forget that sixty years ago most people "), _c('i', [_vm._v("were")]), _vm._v(" growing their own food, with some selling their extra at markets. Contrary to what some people may imagine, the farming vocation is full of rich experiences and interesting people. At the risk of repeating myself, I can definitely say that anyone prepared to invest their time to learn how to grow great vegetables efficiently can succeed in market gardening.")])]), _vm._v(" "), _c('p', {
    staticClass: "footnote1"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Text/#rst1",
      "id": "st1"
    }
  }, [_vm._v("*")]), _vm._v(" In 2005, Équiterre released a study of the production costs on various farms that used the CSA approach. The study report is very helpful when it comes to writing a business plan and can be found in the Bibliography section of this book.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78640360","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Chapter002.vue
// module id = 87
// module chunks = 0